import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import BoxWrapper1 from './BoxWrapper1';
import BoxWrapper2 from './BoxWrapper2';
import Header from './Header';
import RequestAQuote from './RequestAQuote';

const FulfillmentPage = () => {
  const location = useLocation();
  const wrapperRef = useRef<any>(null);
  useEffect(() => {
    if (location.hash === '#contact') {
      const elementTop = wrapperRef.current.getBoundingClientRect().top;
      const needToScroll = elementTop + wrapperRef.current.scrollTop;
      window.scrollTo(0, needToScroll - 30);
    } else {
      window.scrollTo(0, 0);
    }
    // window.scrollTo(0, 0);
  }, [location, location?.hash]);

  return (
    <>
      <title>Fulfillment | ripify</title>
      <TopSection>
        <Navbar />
        <Header />
      </TopSection>
      <BoxWrapper1 />
      <BoxWrapper2 />
      <div ref={wrapperRef}>
        <RequestAQuote />
      </div>
      <Footer />
    </>
  );
};

export default FulfillmentPage;

const TopSection = styled.div`
  background: #edf2f5;
`;
